import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button, Container, Row, Col, Table, FormControl, FormLabel, Alert, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { logout } from "./actions/auth.js";
import { useSelector } from "react-redux";
import UserDataService from "./services/user.serviceaux.js";
import { useParams } from "react-router-dom";
import { dtFormatter, PageHeader, NewHeader } from './AuxiliaryFunctions';
import kitchenfastquoteService from './services/kitchenfastquote.service.js';
import TopAndSideBar from './TopAndSideBar.js';
import {
  Link,
  BrowserRouter as Router
} from "react-router-dom"
import { FaEdit } from "react-icons/fa";
import { MdKitchen } from "react-icons/md";
import { usdCurrencyFormat } from './numberFormats.js';
import { useDispatch } from 'react-redux';

const Title = styled.h2`
  text-align: center;
  margin-bottom: 1rem;
`;

const SectionTitle = styled.h3`
  margin-top: 2rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  margin-bottom: 0.5rem;
  font-weight: bold;
`;

const Input = styled.input`
  padding: 0.6rem;
  margin-bottom: 1rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
`;


const Message = styled.p`
  color: green;
  margin-top: 1rem;
  text-align: center;
`;

// Example styles
const styles = {
  container: {
    width: '100%',
    margin: 'auto auto',
    padding: '1rem',
    border: '1px solid #ccc',
    borderRadius: '8px',
    textAlign: 'center',
    fontFamily: 'Arial, sans-serif',
  },
  avatar: {
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    objectFit: 'cover',
    marginBottom: '1rem',
  },
};

const kfqTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    View and edit your profile.
  </Tooltip>
); 

const ViewUserProfile = (props) => {
  const dispatch = useDispatch();
  let params = useParams();
  const [profile, setProfile] = useState({});
  const profileid = params ? params.userid : null;
  const { user: currentUser } = useSelector((state) => state.auth);

  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);
  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');

  const [listofkitchenfastquotes, setListofKitchenFastQuotes] = useState([]);  
  const [roles, setRoles] = useState([]);

  useEffect(()=> {
    console.log(currentUser.roles);
    UserDataService.get(profileid) 
    .then(resp => {
      let respdata = resp.data[0];
      let isVerified = respdata.isVerified;
      /*
      if (!isVerified) {
        setShowerror(true);
        setErrmessage("This user profile is not verified.");
        return;
      }
      */
      //console.log(respdata);
      //respdata.roles = respdata.roles.map(rol => rol.id);
      setProfile(respdata);
      setRoles(respdata.roles);
    })
    .catch(err => {
      console.log(err);
      setShowerror(true);
      setErrmessage(err.response.data.message || "An error occurred while fetching the user profile.");
      if (err.response.status === 401) {
        dispatch(logout())
        .then(() => {
          window.location.reload();
        })
        .catch(() => {

        });
      }
    });

    kitchenfastquoteService.getkitchenfastquoteBy(profileid,"id","DESC")
      .then(resp => {
        console.log(resp.data);
        setListofKitchenFastQuotes(resp.data);
      })
      .catch((e) => {
        if (e.response.status == 401) {
          window.location.reload();
          /* // it doesn't recognize dispatch
          dispatch(logout())
          .then(() => {
            window.location.reload();
          });
          */
        }
        else {
          console.log(e.response.data);
          setSuccmessage("");
          setShowsuccess(false);
          setErrmessage(e.response.data);
          setShowerror(true);
        }
      });        
  }, [])

  return (
    <>
    <div style={{display:"flex", flexDirection:"column",width:"100%"}}>
      <TopAndSideBar />
      <NewHeader headerTitle={"User Profile"}/>

      <div style={{display:'flex', flexDirection:'row', gap:'20px'}}>      
        <div style={{display:'block',width:'100%'}}>
          <Container style={{width:"80%"}}>
            <Row>
            <div
              className="card"
              style={{padding:'40px 40px',}}
            >
          
                <div style={{display:'flex',flexDirection:'column',gap:'0px',flexWrap:'wrap'}}>                
                  <div style={styles.container}>
                    <img src={"//ssl.gstatic.com/accounts/ui/avatar_2x.png"} alt={`${(profile.primerapellido + ' ' + (profile.segundoapellido?profile.segundoapellido:"")).trim() + ", " + (profile.primernombre + ' ' + (profile.segundonombre?profile.segundonombre:"")).trim()}'s avatar`} style={styles.avatar} />
                    <h2>{profile.userfirstname + ' ' + profile.userlastname}</h2>
                  </div>
                  <div style={{display:'flex',flexDirection:'row',gap:'10px',flexWrap:'wrap'}}>
                    <label><strong>Name:</strong></label>
                    <label>{profile.userfirstname + ' ' + profile.userlastname}</label>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',gap:'10px'}}>
                    <label><strong>Email:</strong></label>
                    <div>
                      <label>{profile.email}</label>
                      {profile.isVerified ?
                        <label style={{color:'green', marginLeft:'10px'}}> (Verified)</label>
                        :
                        <label style={{color:'red', marginLeft:'10px'}}> (Not Verified)</label>
                      }
                    </div>
                    
                  </div>

                  <div style={{display:'flex',flexDirection:'row',gap:'10px'}}>
                    <label><strong>User Roles:</strong></label>
                    {(roles.map(rol => {
                      return (
                        <label>{rol.rolename}</label>  
                      )
                    }))}
                  </div>

                  <div style={{display:'flex',flexDirection:'row',gap:'10px'}}>
                    <label><strong>Account Created At:</strong></label>
                    <label>{profile.createdAt}</label>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',gap:'10px'}}>
                    <label><strong>Last Updated At:</strong></label>
                    <label>{profile.updatedAt}</label>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',gap:'10px'}}>                    
                    <Button as={Link} to={`/userprofile`}>
                      Update Profile
                    </Button>
                  </div>
                </div>  
                <hr/>

                <div style={{marginBottom:'10px',display:'flex',flexDirection:'row',gap:'20px', justifyContent:'space-between', alignItems:'flex-end'}}>
                  <h5>Kitchen Designs</h5>
                  <Link to={'/new-kitchen-fast-quote'}>
                    <Button>
                      New Kitchen Design
                    </Button>
                  </Link>
                </div>


                <div>
                  
                  <ListKitchenQuotesUser listOf={listofkitchenfastquotes} currentUser={currentUser}/>
                </div>
            </div>
            </Row>

            <Row>
              

            </Row>

            <Row className='mt-2'>
            {showerror && (
              <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
                <Alert.Heading>Error</Alert.Heading>
                <p>{errmessage}</p>
              </Alert>      
            )}
            {showsuccess && (
              <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
                <Alert.Heading>Hecho</Alert.Heading>
                <p>{succmessage}</p>
              </Alert>      
            )} 
            </Row>                  
          </Container>
        </div>
      </div>
    </div>
    </>
  );
};

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'8%'}}>Kitchen Design No.</th>
        <th className='d-none d-sm-table-cell' style={{width:'10%'}}>Special Notes</th>
        <th style={{width:'8%'}}>Created At</th>
        <th className='d-none d-sm-table-cell' style={{width:'8%'}}>Updated At</th>
        <th className='d-none d-sm-table-cell' style={{width:'8%'}}>Total Walls</th>
        <th className='d-none d-sm-table-cell' style={{width:'8%'}}>Total Base Cabinets</th>
        <th className='d-none d-sm-table-cell' style={{width:'8%'}}>Total Wall Cabinets</th>
        <th className='d-none d-sm-table-cell' style={{width:'8%'}}>Total Tall Cabinets</th>
        <th className='d-none d-sm-table-cell' style={{width:'8%'}}>Estimated Quote</th>
        <th style={{width:'8%'}}>Edit</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {  
  const currentUser = props.currentUser;
  if (props.listOf) {
    if (props.listOf.length === 0) {
      return (
        <tbody>
          <tr>
            <td colSpan="12" style={{ textAlign: 'center' }}>
              No kitchen designs found. Why don't you create one? <Link to={'/new-kitchen-fast-quote'}><MdKitchen size={24} /></Link>
            </td>
          </tr>
        </tbody>
      );
    }

    const rows = props.listOf.map((row, index) => {
      const walls = row.walls;
      let totalbasecabinets = [];
      for (var i=0; i<walls.length; i++) {
        let basecabsofthewall = walls[i].rectangles.map(rect => {
          return rect.cabinetConfig;
        });
        totalbasecabinets += basecabsofthewall.length;
      }

      return (
        <>
        <tr key={index}>        
          <td>
            {row.kitchenfastquotenumber}
          </td>
          <td className='d-none d-sm-table-cell'>
            {row.specialnotes}
          </td>          
          <td>  
            {dtFormatter(new Date(row.createdAt),2)}
          </td>
          <td className='d-none d-sm-table-cell' >  
            {dtFormatter(new Date(row.updatedAt),2)}
          </td>
          <td className='d-none d-sm-table-cell' >  
            {walls.length}
          </td>                
          <td className='d-none d-sm-table-cell' >  
            {row.fastquotingcabinetversion?row.fastquotingcabinetversion.baseCabinets:null}
          </td>   
          <td className='d-none d-sm-table-cell' >  
            {row.fastquotingcabinetversion?row.fastquotingcabinetversion.wallCabinets:null}
          </td>   
          <td className='d-none d-sm-table-cell' >  
            {row.fastquotingcabinetversion?row.fastquotingcabinetversion.tallCabinets:null}
          </td>  
          <td className='d-none d-sm-table-cell' style={{textAlign:'right'}} >  
            {usdCurrencyFormat(
              row.fastquotingcabinetversion?
              row.fastquotingcabinetversion.totalquoteversion*(1+row.fastquotingcabinetversion.unknownfactor):
              null
            )}
          </td>  
                                                   
          <td>

            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={kfqTooltip}>        
                <Button>
                  <Link
                    to={`/edit-kitchen-fast-quote/${row.id}`}
                      //search: "?sort=name",
                      //hash: "#the-hash",
                      
                      state= {{
                        zeroIndexWall: row.zeroIndexWall,
                        walls: walls,
                        specialnotes: row.specialnotes,
                        fastquotingcabinetId: row.fastquotingcabinetversion?row.fastquotingcabinetversion.fastquotingcabinetId:null,                        
                        fastquotingcabinetversionId: row.fastquotingcabinetversionId
                      }}
                    
                  >
                    <FaEdit
                      style={{cursor:'pointer'}}
                      color="white"
                    >
                    </FaEdit>                       
                  </Link>                          
                </Button>
            </OverlayTrigger> 

          </td>
        </tr>
        </>      
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const ListKitchenQuotesUser = (props) => {        
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
            <TableHeader/>
            <TableBody listOf={props.listOf} currentUser={props.currentUser}/>
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
};


export default ViewUserProfile;